// BW internal tag vocabulary, shared by TagMapEditor (Tag column dropdown)
// and ImageOrderingEditor (Quick-Add buttons in the modal).
//
// Exterior set: 9 base camera positions from
// src/components/carousel/cameraTagPosition.ts. High/Low variants exist in the
// carousel but the syndicator dev confirmed syndicators won't use them, so we
// keep the dropdown to the 9 bases. Custom values are still typeable via
// freeSolo when an edge case calls for it.
// Cropped and BG-replaced images use the same exterior tag set.
//
// Manual tags are placeholders — the overlay library will eventually drive
// these. For now we seed with the most common manual tags seen in configs.

const EXTERIOR_CAMERA_TAGS = [
  "Left Front",
  "Left Side",
  "Left Rear",
  "Rear",
  "Right Rear",
  "Right Side",
  "Right Front",
  "Front",
  "Roof",
];

export const STANDARD_TAGS_BY_GROUP: Record<string, string[]> = {
  exterior: EXTERIOR_CAMERA_TAGS,
  exteriorOriginal: EXTERIOR_CAMERA_TAGS,
  exteriorProcessed: EXTERIOR_CAMERA_TAGS,
  // Cropped and BG-replaced share the exterior camera vocabulary.
  crop: EXTERIOR_CAMERA_TAGS,
  bgrExterior: EXTERIOR_CAMERA_TAGS,
  bgr: EXTERIOR_CAMERA_TAGS,
  featured: [
    "Left Front Tire",
    "Left Front Fender",
    "Left Qtr Panel",
    "Left Rear Tire",
    "Trunk",
    "Right Rear Tire",
    "Right Qtr Panel",
    "Right Front Tire",
    "Right Front Fender",
    "Hood",
  ],
  pano: ["Pano", "Unassigned"],
  manual: ["Odometer", "Unassigned", "N/A"],
};

export const suggestionsForMap = (mapName: string): string[] => {
  const prefix = mapName.endsWith("_TagMap")
    ? mapName.slice(0, -"_TagMap".length)
    : mapName;
  return STANDARD_TAGS_BY_GROUP[prefix] || [];
};
